export const ACCESSORY_DESCRIPTIONS: Record<string, string> = {
  'ibc-caps':
    'Caps, covers, and plugs attach to valves and openings to contain contents and prevent contamination during storage or transport.',
  'ibc-valves':
    'Valves connect to drainage openings to provide on-off control and flow regulation when dispensing contents.',
  'ibc-adapters':
    'Adapters attach to drainage systems to create compatible connections for different-sized hoses, plugs, valves, and other accessories.',
  'ibc-gaskets':
    'Replacement seals and gaskets ensure tight connections and prevent leaks at valve and cap interfaces.',
  'ibc-stands':
    'Steel elevation stands raise IBC totes for gravity-fed dispensing and forklift access.',
  'ibc-heaters':
    'Blanket heaters wrap around IBC totes to maintain product temperature or prevent freezing.',
  'ibc-liners':
    'Polyethylene liners protect tote interiors and allow for easy product changeover without cleaning.',

  'drum-pumps':
    'Manual and electric pumps transfer liquids from drums safely and efficiently.',
  'drum-faucets':
    'Faucets and spigots provide controlled dispensing from drum bungs.',
  'drum-bungs':
    'Threaded plugs seal drum openings to prevent spills and contamination.',
  'drum-liners':
    'Flexible liners protect drum interiors and simplify cleaning between uses.',
  'drum-covers':
    'Covers and lids protect open-head drum contents from debris and contamination.',
  'drum-heaters':
    'Band and blanket heaters maintain product temperature for viscous materials.',
  'drum-funnels':
    'Funnels direct liquids into drums while preventing spills and splashes.',

  'gaylord-liners':
    'Heavy-duty polyethylene liners protect box interiors and contents from moisture.',
  'gaylord-covers':
    'Elastic and fitted covers protect contents during storage and transport.',
  'gaylord-lids':
    'Replacement lids for damaged or missing gaylord box tops.',

  'bulk-bag-liners':
    'Form-fit liners protect bag interiors and enable handling of fine powders.',
  'bulk-bag-lifters':
    'Forklift attachments for safely lifting and maneuvering bulk bags.',

  'pallet-covers':
    'Clear and thermal covers protect palletized goods from dust, moisture, and temperature changes.',
  'pallet-corner-protectors':
    'Cardboard and plastic protectors prevent strap damage during shipping.',
}

export const ACCESSORY_CATEGORY_HEADERS: Record<string, string> = {
  'ibc-caps': 'IBC Caps, Covers & Plugs',
  'ibc-valves': 'IBC Valves',
  'ibc-adapters': 'IBC Adapters',
  'ibc-gaskets': 'IBC Gaskets & Seals',
  'ibc-stands': 'IBC Stands',
  'ibc-heaters': 'IBC Heaters',
  'ibc-liners': 'IBC Liners',
  'drum-pumps': 'Drum Pumps',
  'drum-faucets': 'Drum Faucets',
  'drum-bungs': 'Drum Bungs',
  'drum-liners': 'Drum Liners',
  'drum-covers': 'Drum Covers',
  'drum-heaters': 'Drum Heaters',
  'drum-funnels': 'Drum Funnels',
  'gaylord-liners': 'Gaylord Liners',
  'gaylord-covers': 'Gaylord Covers',
  'gaylord-lids': 'Gaylord Lids',
  'bulk-bag-liners': 'Bulk Bag Liners',
  'bulk-bag-lifters': 'Bulk Bag Lifters',
  'pallet-covers': 'Pallet Covers',
  'pallet-corner-protectors': 'Pallet Corner Protectors',
}

export const ACCESSORY_KEY_SPECS: Record<string, string[]> = {
  'ibc-caps': ['2" & 6" openings', 'NPT & buttress threads', 'Poly & metal options'],
  'ibc-valves': ['2" ball valves', 'Camlock compatible', 'EPDM & Viton seals'],
  'ibc-adapters': ['NPT to camlock', '2" to 3" reducers', 'S60×6 buttress'],
  'ibc-gaskets': ['Buna-N & EPDM', '2" & 6" sizes', 'FDA compliant options'],
  'ibc-stands': ['Steel construction', '36" height standard', '2,500+ lb capacity'],
  'ibc-heaters': ['120V & 240V', '1,000-2,000W', 'Thermostat control'],
  'ibc-liners': ['275 & 330 gallon', '4-6 mil thickness', 'Form-fit design'],

  'drum-pumps': ['Rotary & lever action', '5-55 gallon drums', 'Stainless & poly'],
  'drum-faucets': ['¾" NPT thread', 'Self-closing option', 'Brass & poly'],
  'drum-bungs': ['2" & ¾" sizes', 'NPT & buttress', 'Steel & poly'],
  'drum-liners': ['55 gallon standard', '4-6 mil thickness', 'Round bottom'],
  'drum-covers': ['22.5" diameter', 'Elastic & snap-on', 'Anti-static options'],
  'drum-heaters': ['Band & blanket styles', '120V standard', '55 gallon fit'],
  'drum-funnels': ['10" & 12" diameter', 'Flame arrestor option', '2" NPT outlet'],

  'gaylord-liners': ['48×40×36" standard', '3-4 mil thickness', '100+ per roll'],
  'gaylord-covers': ['48×40" footprint', 'Clear & opaque', 'Reusable options'],
  'gaylord-lids': ['Triple-wall strength', 'Stackable design', 'Standard pallet fit'],

  'bulk-bag-liners': ['35×35×50" standard', '4-6 mil thickness', 'Form-fit design'],
  'bulk-bag-lifters': ['Forklift mount', '4,000 lb capacity', 'Quick-release'],

  'pallet-covers': ['48×40×48" standard', '1.5-3 mil thickness', 'Clear poly'],
  'pallet-corner-protectors': ['2×2×3" standard', 'Cardboard & plastic', 'Strap guard'],
}
